module.exports = __webpack_public_path__ + "static/media/non_ghe_campo.3cac5dc9.jpg";